export default class TipoChamado{
    _id;
    _descricao; 
    _ativo;
    _cor;
    _som;
    _fonte;
    _borda;
    _corIcone;
    _urgencia;
    _id_principal;
    _codigo;
    
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    
    get descricao() {
        return this._descricao;
    }
    set descricao(value) {
        this._descricao = value;
    }
    
    get ativo() {
        return this._ativo;
    }
    set ativo(value) {
        this._ativo = value;
    }
    
    get cor() {
        return this._cor;
    }
    set cor(value) {
        this._cor = value;
    }
    
    get som() {
        return this._som;
    }
    set som(value) {
        this._som = value;
    }

    get fonte() {
        return this._fonte;
    }
    set fonte(value) {
        this._fonte = value;
    }

    get borda() {
        return this._borda;
    }
    set borda(value) {
        this._borda = value;
    }

    get corIcone() {
        return this._corIcone;
    }
    set corIcone(value) {
        this._corIcone = value;
    }

    get urgencia() {
        return this._urgencia;
    }
    set urgencia(value) {
        this._urgencia = value;
    }

    get id_principal() {
        return this._id_principal;
    }
    set id_principal(value) {
        this._id_principal = value;
    }

    get codigo() {
        return this._codigo;
    }
    set codigo(value) {
        this._codigo = value;
    }

    constructor(pId, pDescricao, pAtivo, pCor, pSom, pFonte, pBorda, pCorIcone, pUrgencia, pIdPrincipal, pCodigo){
        this.id = pId;
        this.descricao = pDescricao;
        this.ativo = pAtivo;
        this.cor = pCor;
        this.som = pSom;
        this.fonte = pFonte;
        this.borda = pBorda;
        this.corIcone = pCorIcone;
        this.urgencia = pUrgencia;
        this.id_principal = pIdPrincipal;
        this.codigo = pCodigo;
    }

}

